import RekonsiliasiService from '@/services/rekonsiliasi';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    
	},

	actions: {
		async getRekonsiliasi({commit, state, getters, dispatch}){
			try{
				const response = await RekonsiliasiService.getRekonsiliasi();
				return response
			}catch(e){
				console.log(e)
			}
		},		
		async createRekonsiliasi({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await RekonsiliasiService.createRekonsiliasi({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
